// User service
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_UPDATE_USER = "AUTH_UPDATE_USER";

// Organization data
export const UPDATE_ORGANIZATION_DATA = "UPDATE_ORGANIZATION_DATA";